import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user :null,
};


export const userSlice = createSlice({
  name: 'user',
  initialState,
  
  reducers: {
    Loginto : (state,action)=> {
      state.user = action.payload;
    },
    Logoutfrom: (state) => {
      
      state.user = null;
    },
  },
});

export const {Loginto, Logoutfrom} = userSlice.actions;


export const selectuser = (state) => state.user.user;

export default userSlice.reducer;
